<template>
  <div class="top_wrapper">
    <div class="top_left">
      <img src="../../assets/image/logo.png" alt class="logo" />
    </div>
    <div class="top_right" v-if="logged">
      <a-popover trigger="click">
        <template slot="content">
          <a-button @click="logout">退出登录</a-button>
        </template>
        <div class="info">
          {{ infoText }}
          <a-icon type="caret-down" />
        </div>
      </a-popover>
    </div>
  </div>
</template>

<script>
import { logout } from '@/api';

export default {
  computed: {
    infoText() {
      let portfolioName =
        (this.$store.getters.portfolioInfo || {}).portfolioName || '';
      return portfolioName ? `欢迎您，${portfolioName}` : '';
    },
    logged() {
      return !!this.$store.getters.token;
    },
  },
  methods: {
    logout() {
      logout().then((res) => {
        if (res.code === 200) {
          this.$store.dispatch('SET_LOGOUT');
          this.$router.push('/login');
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.top_wrapper {
  background: #001529;
  top: 0;
  height: 60px;
  width: 100%;
  position: fixed;
  left: 0;
  right: 0;
  z-index: 1000;
  display: flex;
  justify-content: space-between;
  .top_left {
    display: flex;
    .logo {
      width: 196px;
    }
  }
  .top_right {
    padding-right: 20px;
    display: flex;
    align-items: center;
    color: #ffffff;
  }
}
.info {
  cursor: default;
}
</style>
